import Actions from "./ExpirationsActions";
import Dispatcher from "../common/dispatcher";
import { ExpirationSettingsDto, IExpirationSettingsDto } from "../generated";
import { BaseStore } from "../common/AbstractStores";
import React from "react";

class ExpirationsSettingsStore extends BaseStore {
    private settings: ExpirationSettingsDto | null = null;

    constructor() {
        super();
        Dispatcher
            .onfunction(Actions.getCurrent, data => { this.settings = data; this.Changed.emit(); })
            .onfunction(Actions.save, data => { this.settings = data; this.Changed.emit(); })
            ;
    }
    public useSettings = () => {
        const [item, setItem] = React.useState<ExpirationSettingsDto | null>(this.settings);
        this.useStore(() => setItem(this.settings));
        React.useEffect(() => {
            if (!this.settings)
                Actions.getCurrent();
        }, [])
        return [item, setItem] as [IExpirationSettingsDto | null, (v: IExpirationSettingsDto | null) => void];
    }
}

export default new ExpirationsSettingsStore();